import { useMemo } from "react";
import { useSelector } from "react-redux"

export const useDwlLocationUsers = () => {
  const { dwlUsers } = useSelector((store) => store.settings);
  const { settings } = useSelector((store) => store.personalProfile.organizationLocation);

  const dwlLocationUsers = useMemo(() => (settings?.dwlVerifyContacts || [])
      .map((_id) => dwlUsers.find((dwlUser) => dwlUser._id === _id))
      .filter((user) => !!user)
    , [dwlUsers, settings]);
  
  return { dwlLocationUsers };
}